import { ChevronDownIcon } from '@heroicons/react/24/solid'
import BulldogjobIcon from '../atoms/SocialIcons/BulldogjobIcon'

interface Props {
  title: string
  text: string
  dogClass: string
  links: {
    href: string
    text: string
    plaque?: string
  }[]
}

function ItReportCard({ title, links, text, dogClass }: Props) {
  return (
    <div className='w-full shadow-lg rounded-2xl bg-black border-1 border-black-alter p-10 '>
      <div className='flex justify-center items-center'>
        <BulldogjobIcon width={80} className={`${dogClass} -mt-20`} />
      </div>
      <div className='flex flex-col justify-center items-center mb-4 gap-6 h-56'>
        <h2 className='text-2xl font-semibold mt-10'>{title}</h2>
        <div>{text}</div>
      </div>

      <div className='w-full flex justify-center my-3'>
        <ChevronDownIcon className={`w-10 h-10 mx-auto ${dogClass}`} />
      </div>
      <div className='flex flex-wrap justify-center gap-1'>
        {links.map((link, index) => (
          <a
            href={link.href}
            key={index}
            className='text-blue-500 hover:underline duration-200 pr-4'
          >
            {link.text}
            {link.plaque && (
              <div className='inline-block bg-primary ml-1 rounded-full px-2 py-1 text-xs'>
                {link.plaque}
              </div>
            )}
          </a>
        ))}
      </div>
    </div>
  )
}

export default ItReportCard
